// extracted by mini-css-extract-plugin
export default {"Play":"rbETfW19X4p96RpG5fTq","Loading":"xu7qpS3xYBH64NI5yp3W","Stop":"UYIVPv2zDddEUfwm1z5b"};